import theme from '@theme';
import styled from 'styled-components';

const TitleSection = styled.div`
  font-size: ${theme.fonts.size.xs};
  font-weight: ${theme.fonts.weight.medium};
  color: ${theme.palette.grey[800]};
  padding-left: 1rem;
  position: relative;

  &::before {
    content: '';
    display: inline-block;
    left: 0;
    top: 50%;
    width: 8px;
    height: 8px;
    transform: translateY(-50%);
    position: absolute;
    background: ${theme.palette.blue[300]};
    border-radius: 25%;
  }
`;

export default TitleSection;
